// extracted by mini-css-extract-plugin
export var backdropBlur = "_ez-0";
export var contentCard = "_ez-5";
export var frame = "_ez-2";
export var image = "_ez-4";
export var imagePane = "_ez-3";
export var modal = "_ez-1";